import WorkflowService from '../../../../../../services/WorkflowService'

class LegacyDecorator {
  async findAll () {
    const originalResponse = await WorkflowService.findAll()
    const workflows = originalResponse.data
    const secundaryPromises = []

    // eslint-disable-next-line no-unused-expressions
    workflows
      ?.forEach(workflow => {
        const promise = WorkflowService
          .findByName(workflow.workflowName)
          .then(secundaryResponse => {
            const completeWorkflow = secundaryResponse.data
            workflow.active = completeWorkflow.active
            workflow.integrationType = completeWorkflow.integrationType
          })

        secundaryPromises.push(promise)
      })

    await Promise.all(secundaryPromises)

    return originalResponse
  }
}

export default new LegacyDecorator()
